// extracted by mini-css-extract-plugin
export default {"sectionHeader":"MobileAccountArtists_sectionHeader__aqg7k"};